import Vue from 'vue';
import  vuex from 'vuex'
Vue.use(vuex);
export default new vuex.Store({
    state: {
        id:'1',
      
    },
    mutations: {
        newSet(state,val){ 
            console.log(val)
            state.id = val
        } 
    },
    getters: {
      
    },
    actions:{
       
    }
});